/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Unsaved_Changes_Modal_DescriptionInputs */

const en_unsaved_changes_modal_description = /** @type {(inputs: Unsaved_Changes_Modal_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You have changes that have not been saved yet. Save them before leaving this page, or discard them.`)
};

const nl_unsaved_changes_modal_description = /** @type {(inputs: Unsaved_Changes_Modal_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Je hebt wijzigingen die nog niet zijn opgeslagen. Sla ze op voordat je deze pagina verlaat, of verwerp ze.`)
};

/**
* | output |
* | --- |
* | "You have changes that have not been saved yet. Save them before leaving this page, or discard them." |
*
* @param {Unsaved_Changes_Modal_DescriptionInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const unsaved_changes_modal_description = /** @type {((inputs?: Unsaved_Changes_Modal_DescriptionInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Unsaved_Changes_Modal_DescriptionInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_unsaved_changes_modal_description(inputs)
	return en_unsaved_changes_modal_description(inputs)
});